import BlurText from "@core-components/BlurText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import CopyText from "@modules/clientDashboard/components/CopyText";

interface ICopyUsernameProps {
  username: string;
  isBlurred?: boolean;
  className?: string;
}

const CopyUsername: React.FC<ICopyUsernameProps> = ({
  username,
  isBlurred,
  className,
}) => {
  const { t } = useAppTranslation("pages.order.tracking.credentials");

  return (
    <BlurText isBlurred={isBlurred}>
      <CopyText
        value={username}
        variant="transparent"
        className={`!text-primary-white hover-scale p-0 ${className}`}
        classNames={{ label: "!text-base font-normal" }}
        notificationLabel={t("copyUsername")}
      >
        {username}
      </CopyText>
    </BlurText>
  );
};

export default CopyUsername;
